import { InroomAdminAction, InroomAdminMutation } from "../types";
import { EarliestInquiryInfo } from "@/framework/network/gql/generated/graphql";

export default {
  [InroomAdminAction.sandboxLogoutMemo]({ commit }: any, data: string) {
    commit(InroomAdminMutation.SET_SANDBOX_LOGOUT_MEMO, data);
  },
  [InroomAdminAction.inquiryInfo]({ commit }: any, data: EarliestInquiryInfo) {
    commit(InroomAdminMutation.SET_INQUIRY_INFO, data);
  },
};
